(function (Drupal) {
  Drupal.behaviors.videoLife = {
    attach: function (context, settings) {
      // Seleccionamos todos los botones con la clase 'lifestory__button'
      const buttons = document.querySelectorAll('.lifestory__button', context);

      buttons.forEach(button => {
        const videoUrl = button.getAttribute('data-video');
        
        if (!videoUrl) {
          // Si no tiene el atributo 'data-video', eliminar el botón
          button.remove();
        } else {
          // Si tiene el atributo 'data-video', agregar el evento click para mostrar el modal
          button.addEventListener('click', function (event) {
            event.preventDefault();
            
            // Seleccionar el modal existente
            const modal = document.querySelector('.lifestory__modal-content');
            const modalBody = modal.querySelector('.lifestory__modal-body');
            
            // Limpiar cualquier contenido previo del modal
            modalBody.innerHTML = '';
            
            // Crear el iframe del video de YouTube con autoplay
            const iframe = document.createElement('iframe');
            iframe.setAttribute('width', '560');
            iframe.setAttribute('height', '315');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${videoUrl}?autoplay=1`);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', true);
            
            // Añadir el iframe al cuerpo del modal
            modalBody.appendChild(iframe);
            
            // Mostrar el modal
            showModal(modal);
          });
        }
      });

      // Función para extraer el ID del video de YouTube de la URL
      function getYouTubeVideoId(url) {
        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length == 11) ? match[2] : null;
      }

      // Función para mostrar el modal (puedes adaptar esto según tu implementación específica)
      function showModal(modal) {
        // Lógica para mostrar el modal
        modal.style.display = 'block';

        // Añadir evento para el botón de cierre
        const closeButton = modal.querySelector('.btn-close.lifestory__modal-close');
        closeButton.addEventListener('click', function () {
          modal.style.display = 'none';
          const modalBody = modal.querySelector('.lifestory__modal-body');
          modalBody.innerHTML = ''; // Remover el iframe para detener el video
        });

        // Añadir evento para cerrar el modal al hacer clic fuera del contenido del modal
        modal.addEventListener('click', function (event) {
          if (event.target === modal) {
            modal.style.display = 'none';
            const modalBody = modal.querySelector('.lifestory__modal-body');
            modalBody.innerHTML = ''; // Remover el iframe para detener el video
          }
        });
      }
    }
  };
})(Drupal);
